import { useNavigate } from 'react-router-dom'
import { ShieldAlert } from 'lucide-react'
import { Button } from '@/components/ui/Button'

/**
 * Tela sem acesso.
 *
 * Aparece quando alguém chega a um endereço do painel que a hierarquia dele não
 * libera — antes disso a página abria normalmente e só as chamadas de API é que
 * eram recusadas, o que parecia defeito em vez de falta de permissão.
 */
export function AccessDeniedPage({ needed }: { needed?: string | null }) {
  const navigate = useNavigate()

  return (
    <div className="flex min-h-[60vh] items-center justify-center px-4">
      <div className="max-w-md text-center">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-amber-50 text-amber-600 ring-1 ring-amber-200">
          <ShieldAlert size={22} />
        </div>
        <h1 className="text-lg font-semibold text-gray-900">Você não tem acesso a esta tela</h1>
        <p className="mt-2 text-sm text-gray-600">
          Esta parte do sistema é liberada pela sua hierarquia. Se precisa dela para o seu trabalho,
          peça a liberação a quem administra o painel.
        </p>
        {needed && (
          <p className="mt-3 text-[11px] text-gray-400">
            Permissão necessária: <span className="font-mono">{needed}</span>
          </p>
        )}
        <div className="mt-6 flex justify-center gap-2">
          <Button variant="secondary" onClick={() => navigate(-1)}>Voltar</Button>
          <Button onClick={() => navigate('/')}>Ir para o início</Button>
        </div>
      </div>
    </div>
  )
}
